import {
  MenuItem,
  Stack,
  useTheme,
  Popover,
  Typography,
  Divider,
  MenuList,
  Button,
  Box,
} from "@mui/material";
import useStyles from "./styles";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const ModalDateTime = ({
  anchorEl,
  setAnchorEl,
  dateInitial,
  dateFinal,
  optionsTimesRange = [],
  setDateInitial = () => {},
  setDateFinal = () => {},
  setChange = () => {},
  clear = () => {},
  relativeInterval = false,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [intervalSeleted, setIntervalSelected] = useState(optionsTimesRange[3]);
  return (
    <Popover
      id={"modal-data"}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={{
        top: dateFinal && dateInitial ? 320 : 310,
        left: 10,
      }}
      sx={styles.paperPoover}
    >
      <>
        <Stack direction="row" spacing={1}>
          <Stack direction="column" spacing={1}>
            <Typography sx={styles.titleDataPicker}>
              Intervalos de tempo absoluto
            </Typography>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={"pt-br"}
            >
              <Stack direction="column" spacing={1}>
                <Stack
                  direction="column"
                  alignItems={"start"}
                  gap={0}
                  justifyContent={"space-between"}
                >
                  <Typography sx={styles.textDataPicker}>
                    Data Inicial
                  </Typography>
                  <DateTimePicker
                    value={dateInitial ? dayjs(dateInitial) : null}
                    onChange={(value) => {
                      setChange(true);
                      setDateInitial(value);
                      setIntervalSelected(null);
                    }}
                    slotProps={styles.dataTime}
                    minutesStep={1}
                    maxDateTime={
                      dateFinal ? dayjs(dateFinal) : dayjs().add(1, "minute")
                    }
                  />
                </Stack>
                <Stack
                  direction="column"
                  alignItems={"start"}
                  gap={0}
                  justifyContent={"space-between"}
                >
                  <Typography sx={styles.textDataPicker}>Data Final</Typography>
                  <DateTimePicker
                    slotProps={styles.dataTime}
                    value={dateFinal ? dayjs(dateFinal) : null}
                    onChange={(value) => {
                      setIntervalSelected(null);
                      setChange(true);
                      setDateFinal(value);
                    }}
                    minDateTime={dayjs(dateInitial).add(1, "minute")}
                    maxDateTime={dayjs().add(1, "minute")}
                    minutesStep={1}
                  />
                </Stack>
              </Stack>
              <Stack direction="row" justifyContent={"flex-end"}>
                <Button
                  variant="text"
                  onClick={() => {
                    clear();
                  }}
                  sx={{ width: "fit-content" }}
                >
                  Limpar
                </Button>
              </Stack>
            </LocalizationProvider>
          </Stack>
          {relativeInterval && (
            <>
              <Divider orientation="vertical" flexItem />
              <Stack direction="column" spacing={1}>
                <Typography sx={styles.titleDataPicker}>
                  Intervalos de tempo relativo
                </Typography>
                <MenuList sx={{ height: "170px", overflow: "auto" }}>
                  {optionsTimesRange.map((option) => (
                    <MenuItem
                      selected={intervalSeleted === option}
                      sx={styles.menuItem}
                      key={option.value + option.unit}
                      onClick={() => {
                        setChange(true);
                        setIntervalSelected(option);
                        setDateInitial(
                          dayjs().subtract(option.value, option.unitEn),
                        ); // Define dinamicamente o tempo
                        setDateFinal(dayjs());
                      }}
                    >
                      {option.value + " " + option.unit}
                    </MenuItem>
                  ))}
                </MenuList>
              </Stack>
            </>
          )}
        </Stack>
      </>
    </Popover>
  );
};

export default ModalDateTime;
